export enum StatusSession {
    CONFIRMED = 'Confirmée',
    CANCELED = 'Annulée'
}
